<div class="fc-product-detail-not-found">
    {{ 'ORDER.PRODUCT_DETAILS.NO_PRODUCT_FOUND' | translate }}
</div>
